import { render, staticRenderFns } from "./AccountHistoryTable.vue?vue&type=template&id=6c50e555&scoped=true&"
import script from "./AccountHistoryTable.vue?vue&type=script&lang=js&"
export * from "./AccountHistoryTable.vue?vue&type=script&lang=js&"
import style0 from "./AccountHistoryTable.vue?vue&type=style&index=0&id=6c50e555&prod&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6c50e555",
  null
  
)

export default component.exports